import React, { useState } from "react";
import { Button, Tooltip } from "antd";
import { InfoCircleOutlined, InfoCircleTwoTone } from "@ant-design/icons";

import "./RestockingFeeToolTip.less";

const RestockingFeeToolTip = (): React.JSX.Element => {
    const [twoToneColor, setTwoToneColor] = useState<
        [string, string] | undefined
    >(undefined);

    const handleOnFocus = (): void => {
        setTwoToneColor(["#00567f", "#cce5f0"]);
    };

    const handleOnBlur = (): void => {
        setTimeout(() => {
            if (twoToneColor !== undefined) {
                setTwoToneColor(undefined);
            }
        }, 0);
    };

    return (
        <Tooltip
            title="The restocking fee is based on if you shipped to a commercial or residential location. We will waive the restocking fee if you select Store Credit as your refund."
            aria-describedby="RestockingFeeInformation"
            trigger={["hover", "focus"]}
            className="restocking-fee-tooltip"
        >
            <Button
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                className="tooltip-button"
                icon={
                    twoToneColor ? (
                        <InfoCircleTwoTone twoToneColor={twoToneColor} />
                    ) : (
                        <InfoCircleOutlined />
                    )
                }
                shape="circle"
                type="text"
                id="RestockingFeeInformation"
                aria-label="The restocking fee is based on if you shipped to a commercial or residential location. We will waive the restocking fee if you select Store Credit as your refund."
            />
        </Tooltip>
    );
};

export default RestockingFeeToolTip;
